import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import './Merchandising.css';

const Merchandising = () => {
  const [activeTab, setActiveTab] = useState('maillots');
  const [hoveredItem, setHoveredItem] = useState(null);

  const products = {
    maillots: [
      {
        id: 1,
        name: 'Maillot de Competición',
        description: 'Tecnología de alta compresión y transpirabilidad',
        price: '$89.900',
        image: '/images/merch/maillot1.jpg',
        hoverImage: '/images/merch/maillot1-alt.jpg'
      },
      {
        id: 2,
        name: 'Maillot Personalizado',
        description: 'Diseño exclusivo para tu equipo o evento',
        price: '$99.900',
        image: '/images/merch/maillot2.jpg',
        hoverImage: '/images/merch/maillot2-alt.jpg'
      }
    ],
    poleras: [
      {
        id: 3,
        name: 'Polera Técnica',
        description: 'Material ultraligero con protección UV',
        price: '$65.900',
        image: '/images/merch/polera1.jpg',
        hoverImage: '/images/merch/polera1-alt.jpg'
      }
    ],
    dorsales: [
      {
        id: 4,
        name: 'Dorsal Premium',
        description: 'Material resistente al agua con chip integrado',
        price: '$12.900',
        image: '/images/merch/dorsal1.jpg'
      }
    ],
    trofeos: [
      {
        id: 5,
        name: 'Trofeo Montaña',
        description: 'Diseño artesanal en acero y madera',
        price: '$45.900',
        image: '/images/merch/trofeo1.jpg'
      }
    ]
  };

  return (
    <div className="merchandising-page">
                      {/* Agregar el Header */}
                      <Header 
                userRole={null}
                username={null} 
                handleLogout={() => {}} 
                setModalOpen={() => {}} 
                setRegisterModalOpen={() => {}} 
            />
      {/* Hero Section */}
      <section className="merch-hero" style={{ backgroundImage: 'linear-gradient(rgba(0,0,0,0.6), url(/images/merch/hero-bg.jpg)' }}>
        <div className="hero-content">
          <h1>Merchandising Personalizado</h1>
          <p>Diseños exclusivos para tus eventos deportivos</p>
          <div className="scroll-indicator">
            <span></span>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="intro-section">
        <div className="intro-content">
          <h2>En INNOVATES SPORT</h2>
          <p>
            Nos apasiona crear experiencias deportivas inolvidables y ofrecer soluciones de merchandising personalizado 
            para eventos de bici montaña y running. Nuestro equipo de expertos en eventos deportivos y diseño gráfico 
            se dedica a diseñar, planificar y ejecutar eventos y productos personalizados que superan las expectativas.
          </p>
        </div>
        <div className="intro-image">
          <img src="/images/merch/intro-image.jpg" alt="Equipo de diseño" />
        </div>
      </section>

      {/* Product Navigation */}
      <nav className="product-nav">
        <button 
          className={activeTab === 'maillots' ? 'active' : ''}
          onClick={() => setActiveTab('maillots')}
        >
          Maillots
        </button>
        <button 
          className={activeTab === 'poleras' ? 'active' : ''}
          onClick={() => setActiveTab('poleras')}
        >
          Poleras
        </button>
        <button 
          className={activeTab === 'dorsales' ? 'active' : ''}
          onClick={() => setActiveTab('dorsales')}
        >
          Dorsales
        </button>
        <button 
          className={activeTab === 'trofeos' ? 'active' : ''}
          onClick={() => setActiveTab('trofeos')}
        >
          Trofeos
        </button>
      </nav>

      {/* Product Gallery */}
      <section className="product-gallery">
        <h3 className="section-title">{activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}</h3>
        <div className="products-grid">
          {products[activeTab].map((product) => (
            <div 
              key={product.id}
              className="product-card"
              onMouseEnter={() => setHoveredItem(product.id)}
              onMouseLeave={() => setHoveredItem(null)}
            >
              <div className="product-image-container">
                <img 
                  src={hoveredItem === product.id && product.hoverImage ? product.hoverImage : product.image} 
                  alt={product.name}
                  className="product-image"
                />
                <div className="product-badge">Personalizable</div>
              </div>
              <div className="product-info">
                <h4>{product.name}</h4>
                <p>{product.description}</p>
                <div className="product-footer">
                  <span className="price">{product.price}</span>
                  <button className="customize-btn">Personalizar</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Advantages Section */}
      <section className="advantages-section">
        <h2 className="section-title">Ventajas de trabajar con nosotros</h2>
        <div className="advantages-grid">
          <div className="advantage-card">
            <div className="icon-container">
              <img src="/images/icons/experience-icon.png" alt="Experiencia" />
            </div>
            <h3>Experiencia y expertise</h3>
            <p>Nuestro equipo tiene años de experiencia en eventos deportivos y diseño gráfico.</p>
          </div>
          <div className="advantage-card">
            <div className="icon-container">
              <img src="/images/icons/quality-icon.png" alt="Calidad" />
            </div>
            <h3>Calidad y precisión</h3>
            <p>Nos aseguramos de que cada producto sea ejecutado con máxima calidad.</p>
          </div>
          <div className="advantage-card">
            <div className="icon-container">
              <img src="/images/icons/custom-icon.png" alt="Personalización" />
            </div>
            <h3>Personalización total</h3>
            <p>Nos adaptamos completamente a las necesidades de cada cliente.</p>
          </div>
        </div>
      </section>

      {/* Customization Demo */}
      <section className="customization-demo">
        <h2>¡Crea tu diseño único!</h2>
        <div className="design-tool">
          <div className="design-preview">
            <img src="/images/merch/design-preview.png" alt="Previsualización diseño" />
          </div>
          <div className="design-options">
            <div className="color-options">
              <h4>Colores</h4>
              <div className="colors-grid">
                {['#FF0000', '#00FF00', '#0000FF', '#FFFF00', '#FFFFFF', '#000000'].map(color => (
                  <div 
                    key={color} 
                    className="color-option" 
                    style={{ backgroundColor: color }}
                  ></div>
                ))}
              </div>
            </div>
            <div className="logo-upload">
              <h4>Añade tu logo</h4>
              <button className="upload-btn">Subir imagen</button>
            </div>
            <button className="preview-btn">Ver diseño final</button>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="contact-content">
          <h2>¿Listo para personalizar tu merchandising?</h2>
          <p>Contáctanos hoy mismo para crear productos únicos para tu evento</p>
          <Link to="/contacto" className="cta-button">Solicitar Cotización</Link>
        </div>
        <div className="contact-image">
          <img src="/images/merch/contact-image.jpg" alt="Equipo de atención" />
        </div>
      </section>
    </div>
  );
};

export default Merchandising;